import clsx from "clsx"

import type { GetButtonClassesTW } from "./types"

export const getButtonClasses: GetButtonClassesTW = ({
  size,
  variant,
  disabled,
  contentInvisible,
  LeftIcon,
  RightIcon,
}) => {
  const isTertiary = variant === "tertiary"
  return {
    container: clsx(
      "relative box-border w-fit rounded-full outline-none transition-colors ease-in-out",
      "inline-flex flex-row flex-nowrap items-center justify-center gap-1",
      "focus-visible:outline-1 focus-visible:outline-primary-700",
      !isTertiary && "outline-offset-2",
      !disabled ? "cursor-pointer" : "cursor-default",
      contentInvisible && "[&>*]:invisible",
      {
        large: clsx("h-12 px-8", LeftIcon && "pl-6", RightIcon && "pr-6", isTertiary && "outline-offset-[-.9rem]"),
        medium: clsx("h-10 px-6", LeftIcon && "pl-4", RightIcon && "pr-4", isTertiary && "outline-offset-[-.7rem]"),
        small: clsx("h-8 px-4", LeftIcon && "pl-3", RightIcon && "pr-3", isTertiary && "hidden"),
      }[size],
      {
        primary: [
          !disabled && ["bg-primary-700 text-white", "hover:bg-primary-800", "active:bg-primary-900"],
          disabled && "bg-neutral-200 text-neutral-700",
        ],
        secondary: [
          "border",
          !disabled && [
            "border-primary-700 bg-transparent text-primary-700",
            "hover:border-primary-800 hover:bg-primary-100 hover:text-primary-800",
            "active:border-primary-900 active:bg-primary-200 active:text-primary-900",
          ],
          disabled && "border-neutral-300 bg-neutral-100 text-neutral-700",
        ],
        tertiary: [
          !disabled && [
            "bg-transparent text-primary-700",
            "hover:text-primary-800 hover:underline",
            "active:text-primary-900 hover:underline",
          ],
          disabled && "text-neutral-700",
        ],
        destructive: [
          "border",
          !disabled && [
            "border-red-700 bg-transparent text-red-700",
            "hover:border-red-800 hover:bg-red-100 hover:text-red-800",
            "active:border-red-900 active:bg-red-200 active:text-red-900",
          ],
          disabled && "border-neutral-300 bg-neutral-100 text-neutral-700",
        ],
      }[variant],
    ),
    text: "select-none truncate whitespace-nowrap py-1",
    icon: "w-5 h-5",
  }
}

export const getAsyncButtonClasses = () => ({
  spinner: "w-3.5 h-3.5 !visible absolute inset-0 m-auto",
})
